import { render, staticRenderFns } from "./agent-activity-table.vue?vue&type=template&id=4fbe5415&"
import script from "./agent-activity-table.vue?vue&type=script&lang=js&"
export * from "./agent-activity-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports